import addToCart from '../lib/addToCart';
import { SELECTORS } from '../utils/constants';

const initAtcForm = () => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getFormProperties = (form) => {
    const prefix = 'properties[';
    return Object.fromEntries(
      [...new FormData(form)]
        .filter(([key]) => key.startsWith(prefix))
        .map(([key, value]) => [key.slice(prefix.length, -1), value])
    );
  };

  const getItem = (form) => {
    const variantId = +form.id.value;
    const quantity = +form.elements['quantity'].value;
    const sellingPlanEl = form.elements['selling_plan'];
    const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;
    const addonProductEl = form.elements['addon_product'];
    const addonProduct = addonProductEl && addonProductEl.value !== '' ? +addonProductEl.value : null;
    const properties = getFormProperties(form);

    return [variantId, quantity, sellingPlan, addonProduct, properties];
  };

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity, sellingPlan, addonProduct, properties] = getItem(evt.target);
      const lineItemKey = await addToCart(variantId, quantity, sellingPlan, properties);
      if (addonProduct) await addToCart(addonProduct, 1, null, { _parentLineItemKey: lineItemKey });
      window.location.href = evt.submitter?.dataset.checkoutUrl;
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
